<template>
  <div class="list-header">

    <div class="list-header-operate">

      <div class="list-header-operate-title">
        <div class="logo" :class="{'logo-en': currentLanguage === 'en'}"></div>
        <div class="expire-time-tips" v-if="$store.expiredTime">
          <i class="plaint-icon mr-5"></i>
          <span class="text-label"> {{$t('core.expire_time')}} : {{$store.expiredTime * 1000 | formatDate}}</span>
        </div>
      </div>

      <div class="tc-g cos-header-operate no-drag-bar">
        <div class="tc-g-u" v-if="allowUpload">
          <qc-bubble type="dark" placement="bottomRight" class="custom-bubble" :append-to-body="false">
            <div ref="transport" class="cos-icon--24 transport" @click="onTabClick('transport')"></div>
            <template slot="popup">{{$t('cos.transfer')}}</template>
          </qc-bubble>
          <!-- 小红点动画/数字 -->
          <div :class="{'setting-red-wrap':!transportAnimationClass,'bubble-animation':transportAnimationClass}"
            v-show="!transportAnimationStartHide&&(totalNum||transportUnread)">
            <div :class="{'setting-red-number':totalNum,'setting-red-point':totalNum===0}">
              <span v-show="totalNum">{{totalNum > 9999? '9999+' : totalNum}}</span>
            </div>
          </div>
        </div>
        <div class="divider" ></div>
        <!-- 语言切换按钮 -->
        <div class="tc-g-u">
          <qc-bubble type="dark" placement="bottomRight" class="custom-bubble" :append-to-body="false">
            <div class="language-switch" @click="toggleLanguage">
              {{currentLanguage === 'zh' ? '中文' : 'EN'}}
            </div>
            <template slot="popup">{{currentLanguage === 'zh' ? $t('cos.switch_to_english') : $t('cos.switch_to_chinese')}}</template>
          </qc-bubble>
        </div>
        <div v-if="!isMobile" class="tc-g-u ">
          <div class="client-operate">
            <qc-bubble placement="bottom" v-show="showOpenClient">
              <a href="javascript:void(0)" class="icon-area" @click="openCOSbrowser">
                <img src="~@/assets/images/computer.svg">
              </a>
              <template slot="popup">
                <span>{{openCosbrowser.name}}</span>
              </template>
            </qc-bubble>
            <qc-bubble placement="bottomRight">
              <div class="icon-area">
                <qc-icon type="phone"></qc-icon>
              </div>
              <template slot="popup">
                <p style="text-align: center; margin-bottom: 10px;">{{$t('cos.view_on_mobile_app')}}</p>
                <qrcode-vue :value="qrcode.value" :size="qrcode.size" level="H"></qrcode-vue>
              </template>
            </qc-bubble>
          </div>
        </div>
        <div v-if="isMobile" class="tc-g-u" style="line-height:24px;">
          <a :href="openCosbrowser.url" target="_blank">
            {{openCosbrowser.name}}
            <i class="external-link-icon"></i>
          </a>
        </div>

      </div>
    </div>

    <!-- dialog -->
    <transport :show.sync="transportShow"></transport>

  </div>
</template>

<script>
import transport from '@/components/dialog/others/transport/index';
import device from 'current-device';
import eventProxy from 'tools/eventProxy';
import QrcodeVue from 'qrcode.vue';
import * as utils from 'tools/utils';
import storage, { StoreKey } from 'tools/storage';
import Cookies from 'js-cookie';

export default {
  components: {
    transport,
    QrcodeVue,
  },
  data() {
    return {
      qrcode: {
        value: '',
        size: 120,
      },
      // hack: 控制传输气泡显示
      transportShow: false,
      clickTransport: false, // 表示是否触发点击动作

      transportTipShow: true,

      // 传输气泡动画
      transportAnimationClass: false,
      transportAnimationStartHide: false,
      transportUnread: false,
      transportAnimationStartTime: 0,
      lastFinishSuccessCount: 0,
      lastFinishErrorCount: 0,
      lastFinishTime: '',

      // 计数器
      uploadTransferring: 0,
      downloadTransferring: 0,
      lastTotalNum: 0,
      openCosbrowser: {
        name: this.$t('cos.open_in_cos_client'),
        url: '', // 基于 tinyurl.com 生成的短连接
      },
      allowUpload: false,
      showOpenClient: false,
      currentLanguage: 'zh', // 默认中文，在 mounted 中会重新设置
    };
  },
  computed: {
    totalNum() {
      return this.$store.uploadNum + this.$store.downloadNum;
    },
    isMobile() {
      return device.mobile() || device.tablet() || device.ipad();
    },
  },
  watch: {
    transportShow(val) {
      if (!val) {
        this.clickTransport = false;
      }
    },
  },
  mounted() {
    // 初始化语言设置
    this.initializeLanguage();
    eventProxy.on('allow-upload', this.whetherAllowUpload);
    eventProxy.on('upload-add', this.onUploadAdd);
    eventProxy.on('upload-list-update', this.updateUploadNum);
    eventProxy.on('show-openClient', () => { this.showOpenClient = true; });
    const shareUrl = window.location.href;
    const nativeScheme = `cosbrowser://com.tencent.qcloud.client/splash?cospath=%2fbrowser%2fshare&url=${encodeURIComponent(shareUrl)}`;
    const downloadLink = `https://a.app.qq.com/o/simple.jsp?pkgname=com.qcloud.cos.client&android_schema=${encodeURIComponent(nativeScheme)}&ios_schema=${encodeURIComponent(nativeScheme)}`;
    this.openCosbrowser.url = downloadLink;
    this.qrcode.value = shareUrl;
  },
  methods: {
    // 初始化语言设置
    initializeLanguage() {
      const initialLanguage = this.getInitialLanguage();
      this.currentLanguage = initialLanguage;
      // 确保 i18n 的 locale 也被设置
      if (this.$i18n) {
        this.$i18n.locale = initialLanguage;
      }
    },
    // 获取初始语言设置
    getInitialLanguage() {
      // 优先从 cookie 中获取 language
      const cookieLanguage = Cookies.get('language');
      if (cookieLanguage) {
        return cookieLanguage;
      }
      // 其次从 localStorage 获取 locale
      const localStorageLocale = localStorage.getItem('locale');
      if (localStorageLocale) {
        return localStorageLocale;
      }
      // 最后使用 i18n 默认语言或 'zh'
      return (this.$i18n && this.$i18n.locale) || 'zh';
    },
    whetherAllowUpload() {
      this.allowUpload = true;
    },
    onUploadAdd() {
      const currentTime = Date.now();
      if (currentTime - this.transportAnimationStartTime <= 600) return;
      this.transportUnread = true;
      this.transportAnimationClass = true;
      this.transportAnimationStartHide = true;
      this.transportAnimationStartTime = Date.now();
      setTimeout(() => {
        this.transportAnimationStartHide = false;
      });
      setTimeout(() => {
        this.transportAnimationClass = false;
      }, 600);
    },
    updateUploadNum(data) {
      // 统计每个状态数字
      const stateMap = {};
      if (data) {
        data.list.forEach(item => {
          stateMap[item.state] = (stateMap[item.state] || 0) + 1;
        });
      }
      // 计算未完成数，正在传输数
      let unfinished = 0;
      let transferring = 0;
      Object.keys(stateMap).forEach(state => {
        const count = stateMap[state];
        if (!['success', 'canceled'].includes(state)) unfinished += count;
        if (['waiting', 'checking', 'uploading'].includes(state)) {
          transferring += count;
        }
      });

      this.$store.uploadNum = unfinished;
      this.uploadTransferring = transferring;
      // 更新界面显示
      this.updateCheckerCount();
    },
    updateCheckerCount() {
      eventProxy.emit('checker.count', {
        unfinished: this.totalNum,
        transferring: this.uploadTransferring + this.downloadTransferring,
      });
      // 如果有数字，突然变成没数字，并且没打开传输弹窗，显示红点
      if (this.lastTotalNum && !this.totalNum && this.transportShow) {
        this.transportUnread = true;
      }
    },
    onTabClick(name) {
      const tipName = `${name}Show`;
      this[tipName] = true;
      if (name === 'transport') {
        this.transportUnread = false;
      }
    },
    openCOSbrowser() {
      utils.tips.loading(this.$t('core.opening'));
      const urlRes = utils.queryStringParse(window.location.search.substr(1));
      const extract = storage.get(StoreKey.EXTRACT);
      const url = `cosbrowser://sharelink/?id=${encodeURIComponent(urlRes.id)}&token=${encodeURIComponent(urlRes.token)}&extract=${extract}&_=${new Date().getTime()}`;
      window.open(url, '_self');
      this.checkCOSBrowserIsOpened();
    },
    // 切换语言方法
    toggleLanguage() {
      const newLocale = this.currentLanguage === 'zh' ? 'en' : 'zh';
      this.$i18n.locale = newLocale;
      this.currentLanguage = newLocale;
      // 保存语言设置到 cookie 和本地存储
      Cookies.set('language', newLocale, { expires: 365 }); // cookie 保存一年
      localStorage.setItem('locale', newLocale);
      // 显示切换成功提示
      // utils.tips.success(newLocale === 'zh' ? '已切换到中文' : 'Switched to English');
    },
    checkCOSBrowserIsOpened() {
      const nextCheck = count => {
        if (count > 5) {
          utils.tips.loading(this.$t('cos.cos_client_not_detected'));
        }
        if (count > 7) {
          // 客户端启动失败，打开COSBrowser下载链接
          window.open('https://cloud.tencent.com/document/product/436/11366', '_blank');
          utils.tips.closeTips();
          return;
        }
        const img = document.createElement('img');
        img.onload = () => {
          utils.tips.closeTips();
        };
        img.onerror = () => {
          setTimeout(() => {
            nextCheck(++count);
          }, 1000);
        };
        img.src = `http://127.0.0.1:9171/active?${Date.now().toString(36)}`;
      };
      // 2s 后开启轮询任务
      setTimeout(() => {
        nextCheck(1);
      }, 2000);
    },
  },
};
</script>

<style scoped lang="scss">
.logo, .expire-time-tips {
  display: inline-block;
  vertical-align: middle;
}
.client-operate {
  height: 24px;
  line-height: 24px;
  display: flex;
  .icon-area {
    cursor: pointer;
    margin: 0 10px;
    img{
      width: 24px;
      height: 24px;
    }
    i {
      width: 20px;
      height: 20px;
      // background-size: cover;
    }
  }
}

// 语言切换按钮样式
.language-switch {
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 24px;
  font-size: 12px;
  font-weight: bold;
  color: #666;
  border-radius: 4px;
  transition: all 0.3s ease;
  &:hover {
    background-color: rgba(0, 0, 0, 0.05);
    color: #333;
  }
}
</style>
